import { render, staticRenderFns } from "./OrdersOfOpenTableModal.vue?vue&type=template&id=0be85570&scoped=true&"
import script from "./OrdersOfOpenTableModal.vue?vue&type=script&lang=js&"
export * from "./OrdersOfOpenTableModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOfOpenTableModal.vue?vue&type=style&index=0&id=0be85570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be85570",
  null
  
)

export default component.exports